import React from 'react';
import {menu} from '../../menu/menu';
import styles from './HeaderMenu.module.css';
import {NavLink} from 'react-router-dom';



const HeaderMenu = () => {
    return (
        <>
        <ul className={styles["menu-list"]}>
            {menu.map(menu => (
                <li key={menu.id}>{menu.url ? <NavLink to={menu.url} >{menu.title}</NavLink> : menu.title}
                    {
                        menu.submenu && 
                        <ul className={styles['menu-list__submenu']}>
                            {menu.submenu.map((submenu, sub_idx) => (
                                <li key={sub_idx}><NavLink to={submenu.url} style={({isActive}) => ({color: isActive ? '#6e54f1' : ''})}>{submenu.subtitle}</NavLink></li>
                            ))}
                        </ul>
                    }
                </li>
            ))}
        </ul>
        </>
    )
}

export default HeaderMenu;